const intervals = {};

export const setCInterval = (id, callback, time) => {
    if (intervals[id]) {
        return intervals[id];
    }
    const intervalId = setInterval(callback, time);
    intervals[id] = intervalId;
    return intervalId;
}

export const stopCInterval = (id) => {
    if (intervals[id]) {
        clearInterval(intervals[id]);
        delete intervals[id];
    }
}

export const stopAllExcept = (protectedId) => {
    Object.keys(intervals).forEach(id => {
        if (id !== protectedId) {
            clearInterval(intervals[id]);
            delete intervals[id];
        }
    });
}